import type { WCollectionGroupView } from '@zola/svc-web-api-ts-client';

import type { CamelCasedPropertiesDeep } from 'type-fest';

import { CollectionGroupTile } from './CollectionGroupTile';

import styles from './collectionGroupGrid.module.less';

export const CollectionGroupGrid = ({
  collectionGroup,
}: {
  collectionGroup: CamelCasedPropertiesDeep<WCollectionGroupView> | null;
}): JSX.Element => {
  return (
    <div className={styles.grid}>
      {collectionGroup?.tileViews?.map((tile, index) => (
        <CollectionGroupTile key={tile.id} tile={tile} lazy={index > 5} />
      ))}
    </div>
  );
};
